<template>
  <div>
    <Header title="我的缓考申请"></Header>
    <div class="my-apply1">
      <p class="apply-ttl" :style="this.applyDetail.auditStatus == '通过' ? 'color: #12DDD6;' : 'color:#F86969;'">{{this.applyDetail.auditStatus}}</p>
      <p class="apply-sub">{{this.applyDetail.courseName}}</p>
      <div class="info-text" v-if="schoolCode=='10488'">
        <p>流程步骤：{{this.applyDetail.shr}}</p>
        <div>
          <van-cell-group inset>
          <div class="pg-progress">
            <!-- 审核流程 -->
            <div class="progress-header">
              <span class="progress-header-title">审核流程</span>
            </div>
            <div class="listDetail-shlc-xjydshzgny">
              <ul>
                <li v-for="(item, index) in lcList" :key="index" :class="item.issh === '1' ?'li-text':''">
                  <div :class="{ 'shlc-circle': true, cur: item.issh === '1'  }">
                    <van-icon
                      v-if="item.issh==='1'"
                      color="#fff"
                      size="18"
                      name="success"
                    />
                    <span v-else>{{ index + 1 }}</span>
                  </div>
                  <span class="shlc-title">
                    {{ item.rolename == "" ? "无" : item.rolename }}
                  </span>
                </li>
              </ul>
            </div>
            <ul class="progress-content">
              <li
                class="progress-content-step"
                v-for="(item, index) in list"
                :key="index"
              >
                <div :class="['progress-content-li-left',
                { fail: item.wfmesname === '不通过' },
                { shz: item.wfmesname === '审核中' },
                { tg: item.wfmesname === '通过' },
                ]">
                  {{ item.wfmesname }}
                </div>
                <ul class="progress-content-li-right">
                  <li class="dw-time">
                    <span style="font-size: 1rem;color: #333;">
                      操作人：{{ item.opername }}
                    </span>
                  </li>
                  <li class="person-status" >
                    <span v-if="index==0">发起时间：{{ item.shsj }}</span>
                    <span v-else class="shr">审核时间：{{ item.shsj }}</span>
                  </li>
                  <li class="person-status" v-if="item.wfprname">
                    <span class="shr">节点名称：{{ item.wfprname }}</span>
                  </li>
                  <li class="remark" v-if="index != 0 && item.shyj">
                    {{ item.shyj == "" ? "无" : item.shyj }}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
       </van-cell-group>
        </div>
        <p>申请时间：{{this.applyDetail.applicationTime}}</p>
        <div class="reason">
          <p>缓考原因：</p>
          <p class="reason-txt">{{this.applyDetail.reason}}</p>
        </div>
      </div>
      <div class="info-text" v-else>
        <p>审核人：{{this.applyDetail.shr}}</p>
        <p>申请时间：{{this.applyDetail.applicationTime}}</p>
        <div class="reason">
          <p>缓考原因：</p>
          <p class="reason-txt">{{this.applyDetail.reason}}</p>
        </div>
        <p>学时：{{this.applyDetail.period}}</p>
        <p>学分：{{this.applyDetail.credit}}</p>
        <p>课号：{{this.applyDetail.courseCode}}</p>
        <p>学年学期：{{this.applyDetail.semester}}</p>
        <p>课程性质：{{this.applyDetail.courseNature}}</p>
        <p>考试方式：{{this.applyDetail.examinationNature}}</p>
        <p>成绩标识：{{this.applyDetail.achievementMark}}</p>
      </div>
    </div>

    <div class="delay-btn" v-if="this.schoolCode==='12561'&&this.applyDetail.auditStatus!='审核中'&&this.applyDetail.auditStatus!='通过'">
      <button  @click="goApply()">重新申请</button>

    </div>
    <div class="delay-btn" v-if="this.schoolCode==='10653'">
      <button  @click="goApply()" v-if="this.applyDetail.auditStatus!='审核中'&&this.applyDetail.auditStatus!='通过'&&this.applyDetail.cjlrrshzt!='2'">重新申请</button>
      <button style="margin-top: 10px" @click="downloadHkpdf()" v-if="this.applyDetail.cj0704hkid!=''">打印</button>

      <button style="margin-top: 10px"  @click="gochexiao()" v-if="this.applyDetail.cjlrrshzt==='2'">撤销</button>
    </div>

  </div>
</template>

<script>
  import {Dialog} from "vant";
  import {Api} from "../../../utils/axios";

  export default{
    data(){
      return{
        applyDetail:[],
          schoolCode: sessionStorage.getItem("schoolCode"),
          lcList:[],
        list:[]
      }
    },
    created(){
      this.applyDetail = JSON.parse(this.$route.query.data)
      console.log(this.applyDetail,'this.applyDetail')
      if(this.schoolCode=='10488'){
        this.getSh();
      }
    },
     methods:{
       goApply(){
           this.$router.push({
               path:'/student/delayApply',
               query:{
                   'data':JSON.stringify(this.applyDetail)
               }
           })
       },
       async getSh(){
        const res = await Api.toKssqShlc({
          stkssqid: this.applyDetail.ywinstanceid
        });
        this.lcList = res.data
        this.list = res.shlc

      },
         gochexiao(){
         Dialog.confirm({
           title: "提示",
           message: "确认撤销？",
         })
           .then(() => {
             const params = {
               cj0704hkid:this.applyDetail.cj0704hkid,
             }
              Api.gocancel(params).then(res => {
                if (res.data==='3'){
                  this.$toast.fail('成绩已送审,无法撤销！')
                }else {
                  this.$toast.fail('撤销成功！')
                  setTimeout(()=>{
                    this.$router.replace('/student/delayedExam');
                  }, 800)
                }
             })
           })
           .catch(() => {
             // on cancel
           });
       },
       async downloadHkpdf(){
         const res = await Api.downloadHkpdf({
           cj0704hkid:this.applyDetail.cj0704hkid,
         })
         if(res.code&&res.code=='0'){
           this.$toast('下载失败！');
         } else{
           const href = URL.createObjectURL(res)
           console.log(href)
           const a = document.createElement('a')
           a.download = "学生缓考通知单"
           a.href = href
           a.click()
         }

       }
     }
  }
</script>

<style lang="less" scoped>
  .my-apply1{padding: 20px;}
  .apply-ttl{font-size: 24px;font-weight: 700;}
  .apply-sub{font-size: 18px;color: @attendance-color-1;font-weight: 700;margin: 20px 0;}
  .my-apply1 .reason{display: flex;}
  .reason-txt{flex: 1;}
  .my-apply1 .info-text{font-size: 14px;color: @attendance-color-2;line-height: 25px;}
  .delay-btn{position: fixed;padding: 20px;width: 100%;text-align: center;bottom: 0;background-color: @attendance-color-3;box-sizing: border-box;}
  .delay-btn button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;width: 100%;border-radius: 3px;}

  .pg-progress {
  margin-top:10px;
  // padding: 0 .9375rem;
  background-color: #fff;
  .pg-gap {
    margin-left: -0.87rem;
    width: calc(100% + 1.74rem);
  }
  .progress-header {
    position: relative;
    text-indent: 11px;
    height: 2.75rem;
    padding: 0 .9375rem;
    line-height: 2.75rem;
    border-bottom: 1px solid #e5e5e5;
    .progress-header-title {
      font-family: PingFangSC-Medium;
      font-weight: bold;
      font-size: 16px;
      color: #333333;
      text-align: center;
    }

    &::before {
      content: "";
      position: absolute;
      left: .9375rem;
      top: 14px;
      width: .25rem;
      height: 1rem;
      background-color: #7469f8;
      border-radius: .125rem;
    }
  }

  .listDetail-shlc-xjydshzgny {
    display: flex;
    justify-content: center;
    background: #f2f2f4;
    padding:10px 10px 0 10px;
    box-sizing: border-box;
    border-radius: 4px;
    margin:15px;
    ul {
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      flex-wrap: wrap;

      li {
        position: relative;
        display: flex;
        // flex-direction: column;
        align-items: center;
        margin-bottom:12px;
        .shlc-circle {
          position: relative;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          font-size: 14px;
          color: #999;
          letter-spacing: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 18px;
          height: 18px;
          background: rgba(255, 255, 255, 0.6);
          border-radius: 50%;
          border: 1px solid #999;
          &.cur {
            background-color: #7469f8;
            &::before {
              position: absolute;
              content: "";
              width: 22px;
              height: 22px;
              border-radius: 50%;
              background: rgba(255, 255, 255, 0.2);
            }
          }
        }
        .shlc-title {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 13px;
          color: #999;
          letter-spacing: 0;
          text-align: center;
          margin-left:5px;
        }
        & + li {
          margin-left: 26px;
          &::before {
            position: absolute;
            content: "";
            width: 20px;
            border:  1px dashed #999;
            right: 103%;
            top: 50%;
          }
        }
      }
      .li-text{
        .shlc-circle{
          color:#7469f8;
          border:1px solid #7469f8;
        }
        .shlc-title{
          color: #7469f8;
        }
        & + li {
          &::before {
            border: 1px solid #7469f8;

          }
        }
      }
    }
  }
  .progress-content {
    padding: 20px .9375rem 0;
    li {
      position: relative;
      display: flex;
      align-items: flex-start;

      &.progress-content-step {
        &:not(:last-child)::before {
          position: absolute;
          content: "";
          top: 43px;
          left: 18px;
          height: calc(~"100% + 26px - 38px - 10px");
          border: 1px solid #d9d9d9;
        }
        & + li {
          margin-top: 26px;
        }
      }

      .progress-content-li-left {
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.625rem;
        height: 2.625rem;
        background-color: #7469f8;
        border-radius: 4px;
        margin-right: 14px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: right;
        line-height: 14px;

        &.fail {
          background: #f85352;
        }
        &.shz {
          background: #FFA400;
        }
        &.tg {
          background: #41B29C;
        }
      }
      .progress-content-li-right {
        flex: 1;
        li {
          margin-bottom: 12px;
          justify-content: space-between;
          &.dw-time {
            display: flex;
            justify-content: space-between;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size:14px;
            color: #999;
            letter-spacing: 0;
            line-height: 16px;
          }
          &.person-status {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #666;
            letter-spacing: 0;
            line-height: 16px;
            .status {
              font-size: .875rem;
            }
            .shr {
              width: 100%;
              word-break: break-all;
            }
          }
          &.remark {
            padding: 10px;
            background: #f2f2f4;
            border-radius: 4px;

            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size:14px;
            color: #666666;
            letter-spacing: 0;
            line-height: 20px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/student/delayTest/myApply1.vue